/** Situação fiscal dos clientes (SITFIS): última conferência, novidades e rotina mensal. */
import { createFileRoute } from '@tanstack/react-router';
import { SituacaoFiscal } from '../telas/integra/situacao-fiscal';

export const Route = createFileRoute('/_app/situacao-fiscal')({ component: SituacaoFiscal });
